var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    height: 100vh;\n    align-items: center;\n    justify-content: center;\n"], ["\n    display: flex;\n    height: 100vh;\n    align-items: center;\n    justify-content: center;\n"])));
export var MessageContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 420px;\n"], ["\n    width: 420px;\n"])));
var templateObject_1, templateObject_2;
